import { type User } from '@/types'

export interface TokenValidationResult {
  isValid: boolean
  claims: {
    userId: { present: boolean; value: string }
    tenantId: { present: boolean; value: string }
    roles: { present: boolean; value: string[] }
  }
}

export function validateTokenClaims(user: User | null): TokenValidationResult {
  const userId = user?.id?.trim() ?? ''
  const tenantId = user?.tenant_id?.trim() ?? ''
  const roles = user?.roles?.filter(r => r.trim().length > 0) ?? []

  const claims = {
    userId: { present: userId.length > 0, value: userId },
    tenantId: { present: tenantId.length > 0, value: tenantId },
    roles: { present: roles.length > 0, value: roles },
  }

  return {
    isValid: claims.userId.present && claims.tenantId.present && claims.roles.present,
    claims,
  }
}
